import Paper from '@mui/material/Paper';
import { useEffect, useState } from 'react';
import { ContextSelect } from '../../component/ContextSelect';
import { CustomersTable } from '../../component/CustomerTable';
import { SubmitButton } from '../../component/SubmitButton';
import { customerRole } from '../../enum/customerRole';
import useAlert from '../../component/Alert/useAlert';
import IngredientAPI from '../../services/ingredient.api.services';
import Title from '../../component/Title';
import { Box, MenuItem, TextField } from '@mui/material';


const TransferIngredient = () => {
    const {showSuccessAlert, showErrorAlert} = useAlert();
    const [state, setState] = useState({
        context: null,
        customer: null,
        target: null,
        ingredients: [],
        ingredient: '',
        quantity: 1,
        buttonDisabled: true,
        loading: false,
    });

    const changeState = (partialState) => setState(currentState => ({...currentState, ...partialState}));
    const startLoading = () => changeState({loading: true});
    const stopLoading = () => changeState({loading: false});

    const quantityChange = ({target: {value}}) =>
        value <= state.ingredient.quantity && changeState({quantity: Number(value)});

    useEffect(() => {
        onCustomerChange()
    }, [state.customer]);

    useEffect(() => {
        changeState({buttonDisabled: !state.customer || !state.target || !state.ingredient || !state.quantity});
    }, [state.customer, state.target, state.ingredient, state.quantity]);

    const onCustomerChange = () => {
        if (!state.customer) {
            changeState({ingredients: [], ingredient: '', quantity: 1})
            return;
        }

        startLoading();
        IngredientAPI
            .getIngredients(state.customer.id)
            .then(result => changeState({ingredients: result.items, ingredient: result.items[0] || ''}))
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading());
    }

    const handleSubmit = () => {
        const data = {
            customer: state.customer?.id,
            destination: state.target?.id,
            quantity: state.quantity,
        };

        startLoading();
        IngredientAPI
            .transferIngredient(state.ingredient.id, data)
            .then(() => showSuccessAlert('NFT successfully transferred'))
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading());
    }

    return (
        <Paper sx={{p: 4, display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
            <Box
                component="form"
                noValidate={false}
                sx={{width: '100%'}}
            >
                <Title>1. Select the Business Context</Title>
                <ContextSelect onContextChange={context => changeState({context, customer: null})}/>
                <Title>2. Select Supplier</Title>
                <CustomersTable
                    context={state.context}
                    role={customerRole.supplier}
                    onCustomerSelect={customer => changeState({customer})}
                />
                <Title>3. Select Basic Ingredient</Title>
                <TextField
                    id="ingredient"
                    name="ingredient"
                    select
                    size="small"
                    fullWidth
                    label="Basic ingredient"
                    value={state.ingredient}
                    disabled={!state.ingredients.length}
                    onChange={event => changeState({ingredient: event.target.value})}
                    required
                    sx={{mb: 1, mt: 1}}
                >
                    {state.ingredients.map(ingredient => (
                        <MenuItem style={{justifyContent: 'space-between'}} key={ingredient.id} value={ingredient}>
                            <span>{ingredient.name}</span>
                            <span> ({ingredient.quantity})</span>
                        </MenuItem>
                    ))}
                </TextField>
                <TextField
                    id="quantity"
                    name="quantity"
                    size="small"
                    fullWidth
                    label="Quantity"
                    disabled={!state.ingredient}
                    value={state.quantity}
                    helperText={state.ingredient ? `Max quantity: ${state.ingredient.quantity}` : ''}
                    onChange={quantityChange}
                    required
                />
                <Title>4. Select target Producer</Title>
                <CustomersTable
                    context={state.context}
                    role={customerRole.producer}
                    onCustomerSelect={target => changeState({target})}
                />
                <SubmitButton
                    text="TRANSFER NFT"
                    loading={state.loading}
                    disabled={state.buttonDisabled || state.loading}
                    handleSubmit={handleSubmit}
                />
            </Box>
        </Paper>
    );
};

export default TransferIngredient;
